import React from 'react';
import { Text, Tooltip } from '@wix/design-system';
import { HeaderLine } from './HeaderLine';
import s from './TaxColumn.scss';
import gridTableStyle from './GridTable.scss';
export const getTaxColumn = ({ t, }) => {
    return {
        header: (React.createElement("div", { className: gridTableStyle.header },
            React.createElement(HeaderLine, { dataHook: "tax-title" }, t('invoice-view:price-quote.view.line-items.tax')))),
        value: (item, index) => (React.createElement(React.Fragment, null, item.taxes.map((tax, taxIndex) => (React.createElement("div", null,
            React.createElement(Text, { key: taxIndex, dataHook: `tax-${index}-${taxIndex}`, className: s.taxItem, size: "small", weight: "normal" },
                React.createElement("span", { style: {
                        minWidth: 0,
                        flex: '0 1 auto',
                    } },
                    React.createElement(Tooltip, { content: tax.name || '', size: "small", className: s.ellipsis }, tax.name || '')),
                "\u00A0",
                React.createElement("span", { style: { flex: '0 0 auto' } },
                    "(",
                    t('invoice-view:price-quote.view.totals.tax-rate-percent', {
                        rate: tax.rate?.serializedValue ?? 0,
                    }),
                    ")"))))))),
        width: 'minmax(70px, 110px)',
    };
};
//# sourceMappingURL=TaxColumn.js.map